export const SET_APPLICATIONS = `${__dirname}/setApplications`;
export const setApplications = applications => {
  return { applications, type: SET_APPLICATIONS };
};

export const UPDATE_APPLICATIONS = `${__dirname}/updateApplications`;
export const updateApplications = applications => {
  return { applications, type: UPDATE_APPLICATIONS };
};

export const UPDATE_APPLICATION_RECRUITER_STATE = `${__dirname}/updateApplicationsState`;
export const updateApplicationRecruiterState = applications => {
  return { applications, type: UPDATE_APPLICATION_RECRUITER_STATE };
};

export const SET_MESSAGE_STATE = `${__dirname}/setMessageState`;
export const setMessageState = application => {
  return { application, type: SET_MESSAGE_STATE };
};
